export const emails = {
  cl: 'contacto@pjchile.com',
  cr: 'servicioalcliente@pjcostarica.com',
  gt: 'servicioalcliente@pjguatemala.com',
  pa: 'atencion@pjpanama.com',
  es: 'atencionalcliente@pjespana.es',
  pt: 'info@papajohns.pt'
};
